import React, { useMemo } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';
import { createPortal } from 'react-dom';
import './Alert.scss';

interface Props {
	title?: string;
	text: string;
	onClose: () => void;
}

export function AlertWrapper(props: any) {
	return (
		<div className='Alert-wrapper' onClick={props.onClick || undefined}>
			{props.children}
		</div>
	);
}

export function SuccessAlert(props: Props) {
	const { title, text, onClose } = props;

	return createPortal(
		<AlertWrapper onClick={onClose}>
			<ToastContainer className='p-3 position-fixed' style={{ zIndex: 2000 }} position='bottom-end'>
				<Toast onClose={onClose} delay={3000} autohide>
					<Toast.Header className='Alert-header success'>
						<strong className='me-auto'>{title || 'Successo'}</strong>
					</Toast.Header>
					<Toast.Body className='Alert-body'>{text}</Toast.Body>
				</Toast>
			</ToastContainer>
		</AlertWrapper>,
		document.body
	);
}
export default SuccessAlert;
